export default __webpack_public_path__ + "static/firepit-a19418dbc371071217583295832734b9.jpg";